/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Document, Page, pdfjs } from "react-pdf";
import Grid from "@material-ui/core/Grid";
import Iframe from "react-iframe";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { ReactDialogBox } from 'react-js-dialog-box'
import 'react-js-dialog-box/dist/index.css'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = (theme) => ({
  container: {
    justifyContent: "center",
    alignItems: "center",
  },
  document: {
    width: "100%",
    height: "100%",
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "25px",
    textTransform: "none",
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
  root: {
    height: "110vh",
    '@media (max-width: 480px)': {
        height: '75vh'
    },
    '@media (max-width: 510px)': {
      height: '80vh'
    }
  },
});

class PDFViewer extends Component {
  state = {
    numPages: null,
    pageNumber: 1,
    windowHeight: undefined,
    windowWidth: undefined,
    zoom: 0.5,
    isOpen: false,
  };

  openBox = () => {
    this.setState({
      isOpen: true
    })
  }

  closeBox = () => {
    this.setState({
      isOpen: false
    })
  }

  goToPrevPage = () => {
    if (this.state.pageNumber - 1 > 0)
      this.setState((state) => ({ pageNumber: state.pageNumber - 1 }));
  };

  goToNextPage = () => {
    if (this.state.pageNumber + 1 <= this.state.numPages)
      this.setState((state) => ({ pageNumber: state.pageNumber + 1 }));
  };

  zoomout = () => {
    this.setState((state) => ({ zoom: state.zoom - 0.3 }));
  };

  zoomin = () => {
    this.setState((state) => ({ zoom: state.zoom + 0.3 }));
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentWillMount() {
    console.log("zooming for : " + this.props.isDesktop);
    // if (!this.props.isDesktop) {
    //   this.setState({ zoom: 2.0 });
    // } else {
    //   this.setState({ zoom: 0.7 });
    // }
  }

  handleResize = () =>
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    var currentWidth = 0;

    if (!this.props.isDesktop) {
      console.log("zooming for : " + this.props.isDesktop);
      this.setState({ zoom: 0.5 });

      setInterval(() => {
        if (currentWidth !== this.state.windowWidth) {
          currentWidth = this.state.windowWidth;

          if (this.state.windowWidth <= 400) {
            this.setState({ zoom: 0.5 });
          } else if (
            this.state.windowWidth > 400 &&
            this.state.windowWidth < 800
          ) {
            this.setState({ zoom: 0.7 });
          } else if (
            this.state.windowWidth >= 800 &&
            this.state.windowWidth < 1200
          ) {
            this.setState({ zoom: 0.7 });
          } else if (this.state.windowWidth >= 1200) {
            this.setState({ zoom: 1.0 });
          }
        }
        console.log(this.state.zoom)
      }, 500);
    }
    else{
      this.setState({ zoom: 0.4 });
    }
  }

  render() {
    const { classes, file, fileURLNoName, wordFile } = this.props;
    var fileMobile =
      "https://drive.google.com/viewerng/viewer?embedded=true&url=" +
      file +
      "#toolbar=1&scrollbar=1";
    var fileMobileNoName =
      "https://drive.google.com/viewerng/viewer?embedded=true&url=" +
      file +
      "#toolbar=1&scrollbar=1";

    let { numPages, pageNumber, zoom } = this.state;
    return (
      <div
        style={{
          textAlign: "center",
          marginBottom: "20px"
        }}
        className={classes.root}
      >
        {this.props.isDesktop && (
          <div style={{ textAlign: "center" }}>
            {this.context.t("Click to open PDF/Word")}
          </div>
        )}

        <div style={{ textAlign: "center", padding: "5px" }}>
          <a style={{ textAlign: "center" }} target="_blank" href={file}>
            {this.context.t("Download PDF")}
          </a>
        </div>

        <div style={{ 
          display: 'flex', 
          marginLeft: 'auto', 
          marginRight: 'auto', 
          justifyContent: 'center'
        }}>
          <Document options={{ workerSrc: "/pdf.worker.js" }} className={classes.docStyle} file={file} onLoadSuccess={this.onDocumentLoadSuccess}>
            <Page 
              scale={this.state.zoom} 
              width={1000} 
              pageNumber={this.state.pageNumber} 
            />
          </Document>
        </div>

        {this.state.isOpen && (
          <>
            <ReactDialogBox
              closeBox={this.closeBox}
              modalWidth='60%'
              headerBackgroundColor='white'
              headerTextColor='white'
              headerHeight='65'
              closeButtonColor='white'
              bodyBackgroundColor='white'
              bodyTextColor='black'
              bodyHeight='200px'
              // headerText='Title'
            >
              <div>
                <h1>Dialog Content</h1>
              </div>
            </ReactDialogBox>
          </>
        )}
        
        <p>
          Page {this.state.pageNumber} of {this.state.numPages}
        </p>
        <div>
          <Button
            type="button"
            disabled={pageNumber <= 1}
            onClick={() => {
              this.goToPrevPage();
            }}
          >
            Previous
          </Button>
          <Button
            type="button"
            disabled={pageNumber >= numPages}
            onClick={() => {
              this.goToNextPage();
            }}
          >
            Next
          </Button>
        </div>

        {/* </div> */}
      </div>
    );
    
  }
}

PDFViewer.contextTypes = {
  t: PropTypes.func,
};

export default withStyles(styles)(PDFViewer);
